export const DRAG_HANDLER_COLUMN_WIDTH = 40;
export const TABLE_ROW_DND_ITEM_TYPE = Symbol('PositionsTableRow');
